const TargetLabel = Object.freeze({
  email: 'Target_Field_Type_Email',
  fs: 'Target_Field_Type_FileStorage',
  fb_ads: 'Target_Field_Type_FacebookAds',
  google_ads: 'Target_Field_Type_GoogleAds'
})

export { TargetLabel }



// WEBPACK FOOTER //
// ./src/modules/automations/enum/TargetEnum.js